<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-7 mt-5 mb-5">
      <mat-card class="mat-elevation-z8" id="card">
        <div class="text-left go-back d-block">
          <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>

          <h2 class="text-center card-title-page">Company Bulk upload</h2>
        </div>

        <app-csv-download-button [downloadTemplateCallback]="downloadCSV"> </app-csv-download-button>

        <h5 class="mb-4">Add a CSV file to create or update your companies in bulk mode</h5>
        <div class="my-4">
          <h6>Columns</h6>
          <code>name</code>, <code>category</code>, <code>status</code>,<code>partnerIdentifier</code>
        </div>
        <div class="my-4">
          <h6>Column Type</h6>
          <p>name(*): <code>required</code></p>
          <p>category: <code>required</code></p>
          <p>
            <span>status(*): </span>
            <code>required</code><br />
            <small>values <code>active | inactive</code></small>
          </p>
          <p>partnerIdentifier(*): <code>required</code></p>
        </div>
        <h6 class="my-4">No comma(,) allowed in data as is used as separator</h6>
        <div class="my-4">
          <h6>Example</h6>
          <div class="csv-code-example py-2 px-3">
            <code>
              name,category,status,partnerIdentifier <br />
              Company 1,Fancy Type,active,{{ getPartnerData() }} <br />
              Company 2,Broker,inactive,{{ getPartnerData() }} <br />
              Company 3,Backend,active,{{ getPartnerData() }} <br />
              Company 4,Provider,inactive,{{ getPartnerData() }} <br />
            </code>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1 mt-4">
            <app-dynamic-form [questions]="questions" (formSubmit)="onSubmit($event)" [disabled]="loading">
            </app-dynamic-form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
